import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const about = () => {


  return (
    <div className='p-5'>
      This page is under construction! Check back soon!
    </div>
  );
};

export default about;
